import { PlannerGlobals } from "src/components/Planner/planner/planner-globals";
import { SERIAL_SPACING } from "src/components/Planner/planner/serial-layout";
import {
  GET_SER_MARG,
  getDeviceById,
  getSerialById,
  getSerialCenter2d,
  getSerialPosProps,
  getSerObj,
  ghostDevProps,
  serialRealLength,
  thereWasGhostDevice,
  uDev
} from "src/components/Planner/planner/uDev";
import { P_xytonum, rotatePointAroundAnotherXY } from "src/components/Planner/planner/uMath";

export function getSerialConnectionProps(serialConnId) {
  const connBaseObj = PlannerGlobals.serialConnections
  .find(conn => conn.id == serialConnId && conn.serialIds.length &&
      conn.serialIds.every(serId => { const ser = getSerialById(serId); return ser && ser.deviceIds.length }));

  if (!connBaseObj) { return false; }

  const firstSerial = getSerialById(connBaseObj.serialIds[0]);
  if (!firstSerial && !firstSerial.deviceIds.length) { return false; }
  const firstDev = getDeviceById(firstSerial.deviceIds[0]);
  if (!firstDev) { return false; }

  const { x, y, angle, roomId } = firstDev;

  const serialsSortedByHeight = connBaseObj.serialIds
  .map(serId => Object.assign({}, getSerialById(serId)))
  .sort((a, b) => a.height - b.height);
  /* .sort((a, b) => b.height - a.height) */

  const deviceIdsWithColRowIdx = {};

  let rowIdx = 0;
  let colNum = 0;
  let devices = [];
  let ghost = false;

  serialsSortedByHeight.forEach((ser, serialIdx) => {
    ser.serialId = ser.id;
    const actualSer = getSerialById(ser.serialId);
    const serObj = getSerObj(actualSer, true);
    ser.serObj = serObj;
    ser.colNum = actualSer.direction == "horizontal" ? ser.serObj.devices.length : 1;
    ser.rowIdx = rowIdx;

    if (ser.colNum > colNum) { colNum = ser.colNum; }

    ser.serObj.devices.forEach(dev => {
      devices.push(dev);
      dev.serialId = ser.serialId;
      if (dev.ghost) { ghost = true; }
    });

    ser.serObj.devices.forEach((dev, devIdx) => {
      const devId = dev.deviceId;
      deviceIdsWithColRowIdx[devId] = { rowIdx: actualSer.direction == "horizontal" ? 0 : devIdx, colIdx: actualSer.direction == "vertical" ? 0 : devIdx };
      if (actualSer.direction == "vertical") {
        rowIdx++;
      }
    });

    if (actualSer.direction == "horizontal") {
      rowIdx++;
    }
  });

  return {
    connId: serialConnId,
    x,
    y,
    angle,
    roomId,
    devices,
    serials: serialsSortedByHeight,
    deviceIdsWithColRowIdx,
    allRowsNum: rowIdx,
    allColsNum: colNum,
    ghost
  }
}

export function isSerialConnectedWithOther(serialId) {
  if (!serialId) { return false; }
  const ser = getSerialById(serialId);
  if (!ser) { return false; }
  return !!PlannerGlobals.serialConnections.find(elem => {
    return !!elem.serialIds.find(currSerId => currSerId == serialId);
  });
}

export function getSerialConnectionForSerialId(serialId) {
  if (!serialId) { return false; }
  const ser = getSerialById(serialId);
  if (!ser) { return false; }
  return PlannerGlobals.serialConnections.find(elem => {
    return !!elem.serialIds.find(currSerId => currSerId == serialId);
  });
}

export function getSerialConnectedPair(serialId) {
  const conn = getSerialConnectionForSerialId(serialId);
  if (conn) {
    const otherSerId = conn.serialIds.find(currSerId => currSerId != serialId);
    if (!otherSerId) { return null; }
    const otherSer = getSerialById(otherSerId);
    if (!otherSer || !otherSer.deviceIds.length) { return null; }
    return otherSer;
  }
  else {
    return null;
  }
}

export function isSerialVertical(serialId) {
  const serial = getSerialById(serialId);
  return serial && serial.direction === "vertical";
}

export function getSerialCenterPos(serialD) {
  if (thereWasGhostDevice()) {
    var props = ghostDevProps();
    if (props.entityType == "serial" && props.entityId == serialD.id) {
      return [props.cx, props.cy];
    }
  }
  var serialCenterDiff = getSerialPosProps(serialD.devices.length,
      serialD.direction);
  return [
    serialD.devices[0].x + serialCenterDiff.centerOffsetX,
    serialD.devices[0].y + serialCenterDiff.centerOffsetY
  ];
}

export function getSerialConnCenterPos(serialConnD) {
  if (thereWasGhostDevice()) {
    var props = ghostDevProps();
    if (props.entityType == "serialconn" && props.entityId
        == serialConnD.connId) {
      return [props.cx, props.cy];
    }
  }
  var serialCenterDiff = getSerialCenter2d(serialConnD.allColsNum,
      serialConnD.allRowsNum).split(" ").map(function (coord) {
    return +coord;
  });
  return [
    serialConnD.devices[0].x + serialCenterDiff[0],
    serialConnD.devices[0].y + serialCenterDiff[1]
  ];
}

export function canSerializeProdWithSerials(prod, serial, changeMode = false) {

  if (prod.is_nhc !== true) {
    return true;
  }

  let success = true;

  if (prod.serializable == true) {
    if (serial.deviceIds.length >= 5 && changeMode === false) {
      return false;
    }

    let foundDevicesInSerial = 0;
    serial.deviceIds.forEach(deviceId => {
      if (PlannerGlobals.devices.find((x, y) => {
        return (x.deviceId === deviceId && x.serializable == true && x.is_nhc
            === true) ? true : false;
      })) {
        foundDevicesInSerial += 1;
      }

    })
    if (foundDevicesInSerial > 3 || (foundDevicesInSerial == 3
        && serial.direction === 'vertical')) {
      success = false;
    }
  }

  return success;

}

export function getSerialBBox_NoDOM(serialId) {
  var ser = getSerialById(serialId);
  if (ser) {
    var devN = serialRealLength(ser);
    var firstDevCenter = P_xytonum(
        uDev.getCenterOfDevice_NoDOM(ser.deviceIds[0]));
    let rotateAngle = ser.angle || 0;
    var ghostProps = ghostDevProps();
    if (ghostProps && ghostProps.entityType == "serial" && ghostProps.entityId
        == serialId) {
      rotateAngle = ghostProps.rot;
    }

    if (isSerialVertical(serialId)) {
      rotateAngle += 90;
    }

    return {
      x: firstDevCenter[0] - PlannerGlobals.DEVICE_SIZE / 2 - GET_SER_MARG(),
      y: firstDevCenter[1] - PlannerGlobals.DEVICE_SIZE / 2 - GET_SER_MARG(),
      width: devN * PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING * (devN - 1)
          + GET_SER_MARG() * 2,
      height: PlannerGlobals.DEVICE_SIZE + GET_SER_MARG() * 2,
      angle: rotateAngle,
      rotateCenter: {x: firstDevCenter[0], y: firstDevCenter[1]},
      transform: `rotate(${rotateAngle} ${firstDevCenter[0]} ${firstDevCenter[1]})`
    }
  }
  return null;
}

export function serialRotatedRectPolygon(serialId, shrinkPcnt = 0) {
  const bbox = getSerialBBox_NoDOM(serialId);
  if (!bbox) {
    return null;
  }

  const shrinkVal = PlannerGlobals.DEVICE_SIZE * shrinkPcnt;
  const x = bbox.x + shrinkVal;
  const y = bbox.y + shrinkVal;
  const height = bbox.height - shrinkVal * 2;
  const width = bbox.width - shrinkVal * 2;

  let pts = [
    {x: x, y: y},
    {x: x + width, y: y},
    {x: x + width, y: y + height},
    {x: x, y: y + height},
  ];

  const rotPts = pts.map(
      pt => rotatePointAroundAnotherXY(pt, bbox.rotateCenter, bbox.angle));

  return rotPts;
}

export function serialsConnectable(serId1, serId2) {
  const s1 = getSerialById(serId1);
  const s2 = getSerialById(serId2);

  if (!s1 || !s2) {
    return false;
  }

  if (isSerialConnectedWithOther(s1.id) || isSerialConnectedWithOther(s2.id)) {
    return false;
  }

  if (Math.abs(s1.height - s2.height) < 12) {
    return false;
  }

  return true;
}

